import { TIANDITU_TK } from '@/config/tianditu'

const SCRIPT_ID = '__tianditu_js_api_v4__'
let loadingPromise = null

/**
 * 加载天地图 JavaScript API 4.0
 * 官方脚本：<script src="http://api.tianditu.gov.cn/api?v=4.0&tk=您的密钥"></script>
 * https://lbs.tianditu.gov.cn/api/js4.0/guide.html
 */
export function loadTianditu (tk = TIANDITU_TK) {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('loadTianditu 只能在浏览器环境使用'))
  }

  if (window.T && window.T.Map) {
    return Promise.resolve(window.T)
  }

  if (loadingPromise) return loadingPromise

  loadingPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID)
    if (existing) {
      existing.addEventListener('load', () => resolve(window.T))
      existing.addEventListener('error', () => reject(new Error('加载天地图 JS API 失败')))
      return
    }

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.type = 'text/javascript'
    // 使用 https，避免在 https 站点出现混合内容问题
    script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${encodeURIComponent(tk)}`
    script.onload = () => resolve(window.T)
    script.onerror = () => reject(new Error('加载天地图 JS API 失败'))
    document.head.appendChild(script)
  })

  return loadingPromise
}





// WEBPACK FOOTER //
// ./src/utils/tianditu.js